"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MAX_UPLOAD_FILE_SIZE_IN_MB = exports.MAX_USER_LAST_NAME_LENGTH = exports.MAX_USER_FIRST_NAME_LENGTH = exports.MAX_EXPENSE_ACCOUNT_CODE_LENGTH = exports.MAX_PAST_LIMIT_YEARS = exports.MAX_FUTURE_LIMIT_YEARS = exports.MAX_TEAM_NAME_LENGTH = exports.MAX_VENDOR_CITY_LENGTH = exports.MAX_VENDOR_NAME_EXTENDED_LENGTH = exports.MAX_VENDOR_NAME_LENGTH = exports.MAX_COST_CENTER_ID_LENGTH = exports.MAX_ROLE_NAME_LENGTH = exports.MAX_INPUT_LENGTH = exports.MIN_INPUT_LENGTH = exports.MAX_INVOICE_NUMBER_LENGTH = exports.MIN_INVOICE_NUMBER_LENGTH = void 0;
exports.MIN_INVOICE_NUMBER_LENGTH = 4;
exports.MAX_INVOICE_NUMBER_LENGTH = 36;
exports.MIN_INPUT_LENGTH = 2;
exports.MAX_INPUT_LENGTH = 253;
exports.MAX_ROLE_NAME_LENGTH = 30;
exports.MAX_COST_CENTER_ID_LENGTH = 36;
exports.MAX_VENDOR_NAME_LENGTH = 50;
/**
 * Max limit for Banking transaction recipient.
 *
 * @see: https://levaroio.atlassian.net/browse/CUS-2247?focusedCommentId=47000
 */
exports.MAX_VENDOR_NAME_EXTENDED_LENGTH = 70;
exports.MAX_VENDOR_CITY_LENGTH = 50;
exports.MAX_TEAM_NAME_LENGTH = 60;
exports.MAX_FUTURE_LIMIT_YEARS = 2;
exports.MAX_PAST_LIMIT_YEARS = 3;
exports.MAX_EXPENSE_ACCOUNT_CODE_LENGTH = 10;
exports.MAX_USER_FIRST_NAME_LENGTH = 100;
exports.MAX_USER_LAST_NAME_LENGTH = 100;
exports.MAX_UPLOAD_FILE_SIZE_IN_MB = 10;
